import { render, staticRenderFns } from "./secondPart.vue?vue&type=template&id=364c9516&scoped=true&"
import script from "./secondPart.vue?vue&type=script&lang=js&"
export * from "./secondPart.vue?vue&type=script&lang=js&"
import style0 from "./secondPart.vue?vue&type=style&index=0&id=364c9516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364c9516",
  null
  
)

export default component.exports